import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Hide } from '@qga/roo-ui/components';
import { Flag } from 'components/PropertyPage/PropertyAvailability/RoomTypes/primitives';
import BusinessRewardsModal from './BusinessRewardsModal';
import BusinessRewardsTooltip from './BusinessRewardsTooltip';
import { POINTS_EARN_ENABLED, POINTS_PER_DOLLAR_DEFAULT } from 'config';
import PointsPerDollar from 'components/PointsPerDollar';

const StyledBox = styled(Box)`
  color: ${themeGet('colors.greys.steel')};
`;

const OfferPointsEarn = React.memo(({ pointsEarned, isClassic, isCurrencyCash, isPointsPlusPay }) => {
  if (!POINTS_EARN_ENABLED) return null;

  const { qbrPoints } = pointsEarned ?? {};
  const pointsPerDollar = pointsEarned?.maxQffEarnPpd ? pointsEarned.maxQffEarnPpd : POINTS_PER_DOLLAR_DEFAULT;

  return (
    <StyledBox borderTop={2} borderBottom={[2, 0]} borderColor="greys.porcelain" mr={[3, 0]} mt={[0, 0, 2]}>
      {!isClassic && (
        <Flag icon="roo" color="brand.primary" my={[3, 6, 6]}>
          <Fragment>
            {(isCurrencyCash || isPointsPlusPay) && (
              <PointsPerDollar pointsPerDollar={pointsPerDollar} display="block" color="greys.steel" />
            )}
            <Hide md lg>
              <BusinessRewardsModal qbrPoints={qbrPoints} />
            </Hide>
            <Hide sm xs>
              <BusinessRewardsTooltip qbrPoints={qbrPoints} />
            </Hide>
          </Fragment>
        </Flag>
      )}
    </StyledBox>
  );
});

OfferPointsEarn.propTypes = {
  pointsEarned: PropTypes.object.isRequired,
  isClassic: PropTypes.bool,
  inclusions: PropTypes.array,
  isCurrencyCash: PropTypes.bool.isRequired,
  isPointsPlusPay: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
};

OfferPointsEarn.defaultProps = {
  inclusions: [],
  isClassic: false,
  isMobile: false,
};

OfferPointsEarn.displayName = 'OfferPointsEarn';

export default OfferPointsEarn;
